import { configureStore } from "@reduxjs/toolkit";
import contactSlice from "./contactSlice";
import scheduleSlice from "./scheduleSlice";

const store = configureStore({
	reducer: {
		contact: contactSlice,
		schedule: scheduleSlice,
	},
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
